module.exports = __webpack_public_path__ + "static/media/default.cf89e8e6.png";